import { createRouter, createWebHistory } from 'vue-router'
import Inicio from '../views/Inicio.vue'
import CasosDeExito from '../views/CasosDeExito.vue'
// import BusquedaLaboral from '../views/BusquedaLaboral.vue'

const routes = [
  {
    path: '/', component: Inicio, meta: {
      title: 'Almoby | Software a medida',
      desc: 'Desarrollamos software, sitios y apps a medida para negocios en crecimiento.',
      canonical: 'https://almoby.com/'
    }
  },
  {
    path: '/servicios', component: Inicio, props: { section: 'servicios' }, meta: {
      title: 'Servicios | Almoby',
      desc: 'Desarrollo web y mobile, integraciones y soporte técnico para tu empresa.',
      canonical: 'https://almoby.com/servicios'
    }
  },
  {
    path: '/nosotros', component: Inicio, props: { section: 'nosotros' }, meta: {
      title: 'Nosotros | Almoby',
      desc: 'Equipo de desarrollo y marketing digital con foco en resultados.',
      canonical: 'https://almoby.com/nosotros'
    }
  },
  {
    path: '/contacto', component: Inicio, props: { section: 'contacto' }, meta: {
      title: 'Contacto | Almoby',
      desc: 'Escribinos y armamos tu solución a medida.',
      canonical: 'https://almoby.com/contacto'
    }
  },
  {
    path: '/casos-de-exito', component: CasosDeExito, meta: {
      title: 'Casos de Éxito | Almoby',
      desc: 'Resultados reales: proyectos desarrollados por Almoby.',
      canonical: 'https://almoby.com/casos-de-exito'
    }
  },
  //  {
  //     path: '/busqueda-laboral',
  //     name: 'busquedaLaboral',
  //     component: BusquedaLaboral
  //   }
  // catch-all opcional → redirige a Inicio
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

const sectionMap = {
  '/nosotros': '#sobreNosotros',
  '/servicios': '#nuestrosServicios',
  '/contacto': '#contacto'
};

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;

    // Si viene con #hash (por si lo usás en algún lado)
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }

    // Rutas “virtuales” que deben scrollear a secciones del Home
    if (sectionMap[to.path]) {
      return { el: sectionMap[to.path], behavior: 'smooth' };
    }

    // Resto: al top
    return { left: 0, top: 0 };
  },
});

function setJsonLd(id, data) {
  const prev = document.getElementById(id);
  if (prev) prev.remove();
  const s = document.createElement('script');
  s.type = 'application/ld+json';
  s.id = id;
  s.text = JSON.stringify(data);
  document.head.appendChild(s);
}

router.afterEach((to) => {
  const meta = to.meta || {};
  const t = typeof meta.title === 'string' ? meta.title : null;
  const d = typeof meta.desc === 'string' ? meta.desc : null;
  const c = typeof meta.canonical === 'string' ? meta.canonical : null;

  if (t) document.title = t;

  // <meta name="description">
  let md = document.querySelector('meta[name="description"]');
  if (!md) {
    md = document.createElement('meta');
    md.setAttribute('name', 'description');
    document.head.appendChild(md);
  }
  if (d) md.setAttribute('content', d);

  // <link rel="canonical">
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  if (c) link.setAttribute('href', c);
  // Breadcrumbs por ruta
  const names = {
    '/servicios': 'Servicios',
    '/nosotros': 'Nosotros',
    '/contacto': 'Contacto',
    '/casos-de-exito': 'Casos de Éxito'
  };

  if (names[to.path]) {
    setJsonLd('ld-breadcrumbs', {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Inicio", "item": "https://almoby.com/" },
        { "@type": "ListItem", "position": 2, "name": names[to.path], "item": `https://almoby.com${to.path}` }
      ]
    });
  } else {
    const prev = document.getElementById('ld-breadcrumbs');
    if (prev) prev.remove();
  }

  const ensureMeta = (attr, key, value) => {
    let m = document.querySelector(`meta[${attr}="${key}"]`);
    if (!m) { m = document.createElement('meta'); m.setAttribute(attr, key); document.head.appendChild(m); }
    if (value) m.setAttribute('content', value);
  };
  ensureMeta('property', 'og:title', t);
  ensureMeta('property', 'og:description', d);
  ensureMeta('property', 'og:url', c);
  ensureMeta('name', 'twitter:title', t);
  ensureMeta('name', 'twitter:description', d);
});

export default router
